import React, { useEffect } from 'react';
import {
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation,
} from 'react-router-dom';
import './App.css';

// Pages
import Login from './pages/Login';
import { Dashboard } from './pages/Dashboard/Dashboard';
import { Questions } from './pages/Questions/Questions';
import { Cover } from './pages/Cover/Cover';
import { Chapter } from './pages/Chapter/Chapter';
import { Photos } from './pages/Photos/Photos';
import { Influencer } from './pages/Influencer/Influencer';
import Terms from './pages/Terms';

// Guards
import { BookStatusGuard } from './components/BookStatusGuard/BookStatusGuard';

function AuthGuard({ children }: { children: React.ReactNode }) {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token && location.pathname.includes('/forms')) {
      navigate('/login', { replace: true });
    }
  }, [location.pathname, navigate]);

  return <>{children}</>;
}

function App() {
  return (
    <AuthGuard>
      <Routes>
        {/* Root → client cabinet (AuthGuard sends guests to /login). */}
        <Route path="/" element={<Navigate to="/forms" replace />} />

        {/* Public */}
        <Route path="/login" element={<Login />} />
        <Route path="/terms" element={<Terms />} />
        {/* Old comabooks.org address of the same page. */}
        <Route path="/policies" element={<Terms />} />

        {/* Protected */}
        <Route path="/forms" element={<Dashboard />} />
        <Route path="/influencer" element={<Influencer />} />
        <Route
          path="/forms/questions/:id"
          element={<BookStatusGuard><Questions /></BookStatusGuard>}
        />
        <Route
          path="/forms/cover/:id"
          element={<BookStatusGuard><Cover /></BookStatusGuard>}
        />
        <Route
          path="/forms/photos/:templateId/:photoId"
          element={<BookStatusGuard><Photos /></BookStatusGuard>}
        />
        <Route
          path="/forms/chapter/:templateId/:chapterId"
          element={<BookStatusGuard><Chapter /></BookStatusGuard>}
        />

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthGuard>
  );
}

export default App;
